import preact from 'preact'
import common from '../../libs/common'
import tracker from '../../components/tracker/publish'
import TopicHelpfulness from './topicHelpfulness'
import Portal from 'preact-portal'
import $ from 'jquery'
import getTopicType from '../../utils/getTopicType'
import { CONTENT_HELPFULNESS_VOTE_URL, CONTENT_HELPFULNESS_SETTINGS_URL, ratingDataMap } from 'libs/config'

class TopicHelpfulnessContainer extends preact.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: null,
      isDismissed: false,
      isRemoved: false,
      isSticky: false,
      animationClass: null,
      visible: false,
      indicatorEnabled: false,
      helpfulnessPercentage: null,
      configurationLoaded: false
    }
    this.setData = this.setData.bind(this)
    this.hideWidget = this.hideWidget.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.oldScroll = window.pageYOffset || document.documentElement.scrollTop
  }

  updateStorage () {
    let data = JSON.parse(window.localStorage.getItem('topicHelpfulness')) || {}
    data[this.props.topic.id] = { value: this.state.value, isDismissed: this.state.isDismissed, isRemoved: this.state.isRemoved }
    window.localStorage.setItem('topicHelpfulness', JSON.stringify(data))
  }

  removeWidget () {
    this.setState({ isRemoved: true }, () => this.updateStorage())
  }

  hideWidget () {
    window.removeEventListener('scroll', this.onScroll)
    this.setState({ animationClass: 'easy-out' })
    window.setTimeout(() => {
      this.setState({ isDismissed: true, isSticky: false, animationClass: '' })
    }, 300)
  }

  setData (value) {
    this.setState({ animationClass: 'fade-out' })

    window.setTimeout(() => {
      this.setState({ value: value, animationClass: '' })
      window.setTimeout(() => {
        this.hideWidget()
      }, 3000)
    }, 300)

    common.getGATokens()
      .then((tokens) => {
        tokens.forEach((token) => {
          window.ga(`${token}.send`, 'event', 'Topic helpfulness', ratingDataMap.ga[value])
        })
      })
      .catch(() => {})

    tracker.trackEvent('userevent', {
      type: 'Topic Rated',
      rating: ratingDataMap.messagebus[value],
      topic_title: this.props.topic.title,
      topic_type: getTopicType(this.props.topic.prefixId, this.props.topic.contentType),
      topic_id: this.props.topic.id,
      topic_url: window.location.origin + window.location.pathname,
      topic_views: this.props.topic.views,
      source: 'community'
    })

    $.post(CONTENT_HELPFULNESS_VOTE_URL, { topic: this.props.topic.id, vote: value })
  }

  componentDidMount () {
    const data = JSON.parse(window.localStorage.getItem('topicHelpfulness')) || {}
    if (data[this.props.topic.id]) {
      const { value, isDismissed, isRemoved } = data[this.props.topic.id]
      if (!isRemoved) {
        this.getConfiguration()
      }
      this.setState({ value, isDismissed, isRemoved })
    } else {
      this.getConfiguration()
    }

    window.addEventListener('beforeunload', () => {
      if (this.state.value) {
        this.removeWidget()
      }
    })

    if (!this.state.isDismissed) {
      const boundaries = this.getScrollBoundaries()
      if (boundaries.firstPost < 0 && (!boundaries.hasReplyBox || boundaries.replyBoxTop)) {
        this.setState({ isSticky: true })
      }
      window.addEventListener('scroll', this.onScroll)
    }
  }

  onScroll () {
    const isSticky = this.state.isSticky
    const boundaries = this.getScrollBoundaries()

    const newScroll = window.pageYOffset || document.documentElement.scrollTop

    if (newScroll < this.oldScroll) {
      this.oldScroll = newScroll
    } else {
      this.setState({ isSticky: false })
      this.oldScroll = newScroll
      return
    }

    if (!isSticky && boundaries.firstPost < 0 && (!boundaries.hasReplyBox || boundaries.replyBoxTop)) {
      this.setState({ isSticky: true })
    } else if (isSticky && (boundaries.firstPost > 0 || (boundaries.hasReplyBox && boundaries.replyBoxBottom))) {
      this.setState({ isSticky: false })
    }
  }

  getScrollBoundaries () {
    const firstPost = document.querySelector('.qa-topic-first-post').getBoundingClientRect()
    const hasReplyBox = document.querySelector('.qa-reply') !== null
    const replyBox = hasReplyBox && document.querySelector('.qa-reply').getBoundingClientRect()

    return {
      firstPost: firstPost.height + firstPost.top,
      replyBoxTop: replyBox.top > window.innerHeight,
      replyBoxBottom: replyBox.top < window.innerHeight,
      hasReplyBox: hasReplyBox
    }
  }

  getConfiguration () {
    if (!this.state.configurationLoaded) {
      $.get(CONTENT_HELPFULNESS_SETTINGS_URL, {
        topicId: this.props.topic.id,
        topicType: getTopicType(this.props.topic.prefixId, this.props.topic.contentType)
      })
        .then(function (data) {
          this.setState({
            visible: data.visible,
            indicatorEnabled: data.indicatorEnabled,
            helpfulnessPercentage: data.helpfulnessPercentage,
            configurationLoaded: true
          })
        }.bind(this))
        // TODO: do we want to handle this on FE?
        // .fail(function (e) {
        //   throw e
        // })
    }
  }

  componentDidUpdate () {
    this.updateStorage()
  }

  render (props, state) {
    const isVoted = state.value
    if (state.isRemoved || (state.isDismissed && state.isSticky) || !state.visible) {
      return null
    }
    const topicHelpfulness = <TopicHelpfulness
      setData={this.setData}
      hideWidget={this.hideWidget}
      isVoted={isVoted}
      isSticky={state.isSticky}
      phrases={props.phrases.Forum}
      showIndicator={state.indicatorEnabled}
      indicatorPercentage={state.helpfulnessPercentage}
      animationClass={state.animationClass}
    />

    return (
      <div>
        {topicHelpfulness}
        {state.isSticky ? (<Portal into={'#comments'}>{topicHelpfulness}</Portal>) : null}
      </div>
    )
  }
}

export default TopicHelpfulnessContainer
